import {
  Markdown,
  SyntaxHighlighter,
} from '@frontendmentorio/design-system-v2';

import Header from './Header';
import Recommendation from './Recommendation';

export default function Issue({ currentUser, handleClick, issue, isAuthor }) {
  const file = issue.file?.split(':')[0];
  const language = file?.split('.').pop() || 'html';

  return (
    <article className="bg-neutral-50 border border-neutral-200 flex flex-col gap-3 items-start p-3 rounded-lg">
      <Header issue={issue} />

      {issue.description && <Markdown>{issue.description}</Markdown>}

      {issue.context && (
        <pre className="bg-neutral-100 border border-neutral-200 overflow-x-auto p-1 rounded-lg text-sm w-full *:bg-inherit">
          <SyntaxHighlighter language={language}>
            {issue.context}
          </SyntaxHighlighter>
        </pre>
      )}

      {issue.file && language !== 'html' && (
        <small className="flex gap-2 italic text-sm">{issue.file}</small>
      )}

      <Recommendation
        currentUser={currentUser}
        isAuthor={isAuthor}
        issue={issue}
        onClick={handleClick}
      />
    </article>
  );
}
